import React from "react";

const InsightPage = () => {
  return <div>This is a Insight Page</div>;
};

export default InsightPage;
